
import Vue from 'vue'
import { mapGetters } from 'vuex';
import { autoTranslate } from '@/helpers/autoTranslate';

export default Vue.extend({
  props: {
    input: { type: Object, default: () => {} },
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    callFunction: { type: Function, default: () => () => {} },
    onChange: { type: Function, default: () => {} },
    parent: { type: Object, default: () => {} },
    errorResponse: { type: Object, default: () => {} },
    groupItemKey: { type: Number, default: -1 },
    rowDisabled: { type: Boolean, default: false }
  },
  data(): any {
    return {
      tempVariable: ''
    }
  },
  computed:{
    autoTranslatedLabel: function(): string {
      return autoTranslate(this.input.label);
    },
    goodsId: function(): any {
      return this.parent._resolveFormulaValue(this.input.goodsId)
    },
    resolveInputValue: function(): any {
      if(this.input.inputType === 'formula') {
        const _variable = this.getVariable(this.input.variable);
        const _item = this.getVariable(this.input.items);
        let resolvedValue = this.parent._resolveFormulaValue(this.input.formula, {_item, _variable}, this.groupItemKey);
        try {
          resolvedValue = JSON.parse(resolvedValue);
        } catch { 
          if (/^\{[^{]/g.test(resolvedValue)) {
            this.$store.commit('setSnackbar', { serverMessage: 'resolveInputValue: invalid json object!', show: true, color: 'error' });
          }
        }
        return resolvedValue;
      }
      return this.getVariable(this.input.variable);
    },
    ...mapGetters(['getErrorFor'])
  },
  mounted() {
    if(this.input.tempValueFormula) {
      this.$watch(
        () => this.parent._resolveFormulaValue(this.input.tempValueFormula), 
        (tempValue: any) => {
          if (tempValue && this.tempVariable === '') {
            this.tempVariable = tempValue;
          }
        },
        {
          immediate: true, deep: true
        }
      )
    }
  }
})
